export function swBackspace(sharedModule) {
  /**
   * # swBackspace
   */
  sharedModule.directive('swBackspace', () => ({
    restrict: 'A',
    require: '^swPad',

    link: function postLink(scope, element, attr, swPadCtrl) {
      element.on('click', () => {
        scope.$apply(() => {
          swPadCtrl.backspace();
        });
      });
    },
  }));
}
